export const ShippingTabType = {
  shipment: 'shipment',
  reception: 'reception',
  history: 'history',
} as const;
